import survey from './survey';
import programSurvey from './program-survey';

export default {
  ...survey,
  ...programSurvey,
};
